import { Request } from "sp-react-commons";
// import Uri from '../../commons/utils/Uri';
import Uri from '../../../utils/Uri';
import Translation from '../../commons/i18n/Translation';
import Constants from "../configurations/Constants";


export class PostApi {
    static getPostsOrEventsBeforeDate(beforeTimeStamp, contentType) {
        var query = {
            beforeTimeStamp: beforeTimeStamp,
            limit: Constants.POST_BY_CALL,
            filter: contentType
        };
        return Request.get(Uri.buildQuery(`/api/v1/${Translation.getLanguageName()}/mywort/posts`, query));
    }

    static getEventsAfterDate(afterDate, excludeIds) {
        var query = {
            afterDate: afterDate,
            limit: Constants.POST_BY_CALL,
            excludeIds: excludeIds
        };
        return Request.get(Uri.buildQuery(`/api/v1/${Translation.getLanguageName()}/mywort/events`, query));
    }

    static getLatestGroups(skip) {
        var query = {
            skip: skip
        };
        return Request.get(Uri.buildQuery(`/api/v1/${Translation.getLanguageName()}/mywort/groups`, query));
    }

    static getLatestLocalities(skip) {
        var query = {
            skip: skip
        };
        return Request.get(Uri.buildQuery(`/api/v1/${Translation.getLanguageName()}/mywort/localities`, query));
    }

    static getPostBeforeDate(beforeTimeStamp) {
        return PostApi.getPostsOrEventsBeforeDate(beforeTimeStamp, Constants.CONTENT_FILTER.POST)
    }

    static getEvents(date, excludeIds) {
        return PostApi.getEventsAfterDate(date, excludeIds)
    }

    static unlinkPost(postId) {
        return Request.get(`/api/v1/mywort/post/${postId}/unlink`);
    }
}

export class UserApi {
    static getUserPosts() {
        return Request.get('/api/v1/mywort/posts/own/search');
    }
}

export class GroupApi {
    static createGroupRequest = (groupRequest) => Request.post('/api/v1/mywort/groups/create', groupRequest);
    static getGroupRequest = (legacyUserId) => Request.get(`/api/v1/mywort/groups/myrequest/legacy/${legacyUserId}`);
    static createJoinGroupRequest = (joinGroupRequest) => Request.post('/api/v1/mywort/groups/join', joinGroupRequest);
    static getJoinRequest = (groupId) => Request.get(`/api/v1/mywort/groups/${groupId}/myjoins`);
    static getGroup = (groupId) => Request.get(`/api/v1/mywort/groups/${groupId}`);
}

export class SearchApi {
    static searchPosts = (filters) => Request.get(Uri.buildQuery(`/api/v1/${Translation.getLanguageName()}/mywort/search`, filters));
    static searchGroup = (filters) => Request.get(Uri.buildQuery(`/api/v1/${Translation.getLanguageName()}/mywort/groups/search`, filters));
    static searchLocality = (filters) => Request.get(Uri.buildQuery(`/api/v1/${Translation.getLanguageName()}/mywort/localities/search`, filters));
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/api/Api.js